import * as React from 'react';
import * as classes from './logout.scss';

export interface LogoutComponentProperties {
  readonly isLoggedIn: boolean;
  readonly logoutClicked: () => void;
  readonly message: string;
}

export class LogoutComponent extends React.Component<LogoutComponentProperties> {
  render() {
    if (this.props.isLoggedIn) {
      return (
        <div className={classes.logout}>
          <span onClick={e => this.props.logoutClicked()}>
            Logout <i className="fa fa-fw fa-sign-out-alt" />
          </span>
          {/* <span>{this.props.message}</span> */}
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/_components/logout.component.tsx